import { Button, Form, Col, Offcanvas, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { BsEye, BsEyeSlash } from "react-icons/bs";
import Select from 'react-select';
import { Link, useNavigate } from "react-router-dom";
import HelperService from "../../utility/HelperService";
import WebService from "../../utility/WebService";
import { Label } from "../../components/Label/Label";
import { EMAIL_REGEX } from "../../utility/constants";
import loader from "../../assets/images/loader.gif";

interface PropData {
    isShow: boolean;
    isClose: Function;
    data: any;
}

interface formInterface {
    id: number
    uuid?: string
    agent_name: string
    agent_phone: string | number
    comission: number;
    agent_projects?: { id: number; project_name: string; commission: number }[];
    commission_amount?: number
    commission_type?: string
    agent_email?: string
    status?: string
    created_by?: number
    created_at?: Date
    updated_at?: Date
}

const commissionTypeOptions = [
    { value: "amount", label: "Amount" },
    { value: "percentage", label: "Percentage" },
]

const AddAgent = (props: PropData) => {
    const { handleSubmit, formState: { errors }, control, watch, reset, setValue } = useForm<formInterface>({});
    const watchAllFields = watch();
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [projectOptions, setProjectOptions] = useState<any[]>([]);
    const [agentProjectOptions, setAgentProjectOptions] = useState<any[]>([]);
    const [loadingAgentProjectOptions, setLoadingAgentProjectOptions] = useState<boolean>(false);

    useEffect(() => {
        if (props.isShow) {
            if (props.data && !HelperService.isEmptyObject(props.data)) {
                reset(props.data);
                setIsEdit(true);
            } else {
                reset({});
                resetForm();
                setIsEdit(false);
            }
            !projectOptions.length && getProjectList()
            getAgentProjectList()
        }
    }, [props.isShow, props.data]);

    const handleFormSubmit = (data: formInterface) => {
        data.agent_phone = Number(data.agent_phone.toString().replaceAll("-", ""));
        data.agent_projects = agentProjectOptions;
        const url = isEdit ? `agent/update` : "agent/create";
        WebService[isEdit ? "putAPI" : 'postAPI']({
            action: url, body: data, id: "changePassword-btn",
        }).then((res: any) => {
            toast.success(res.message);
            closeModal(true);
        }).catch(() => { });
    };

    const getProjectList = () => {
        WebService.getAPI({
            action: "get/project/list",
        }).then((res: any) => {
            var projectList = res.list.map((item: any) => {
                return { ...item, value: item.id, label: item.project_name };
            });
            setProjectOptions(projectList);
        });
    };

    const getAgentProjectList = () => {
        setLoadingAgentProjectOptions(true);
        WebService.getAPI({ action: `agent-project/list?agent_uuid=${props.data?.uuid ?? ""}` }).then((res: any) => {
            setAgentProjectOptions(res.list);
            setLoadingAgentProjectOptions(false);
        }).catch(() => setLoadingAgentProjectOptions(false));
    };

    const closeModal = (e: boolean) => {
        setAgentProjectOptions([]);
        reset();
        resetForm();
        props.isClose(e);
    };

    const resetForm = () => {
        setValue('agent_name', '');
        setValue('agent_email', '');
        setValue('agent_phone', '' as any);
        setValue('comission', "" as any);
    };

    return (
        <>
            <Offcanvas show={props.isShow} onHide={props.isClose} placement="end" className="offcanvas-large">
                <Offcanvas.Header closeButton><Offcanvas.Title>{isEdit ? "Edit Agent" : "Add Agent"}</Offcanvas.Title></Offcanvas.Header>
                <Offcanvas.Body className="form-style">
                    <form className="form-style" onSubmit={handleSubmit(handleFormSubmit)}  >
                        <Row>
                            <Col lg={12} md={6} sm={12} className="mb-3">
                                {/* Name */}
                                <Controller
                                    control={control}
                                    name="agent_name"
                                    rules={{ required: "Please Enter Name" }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Name</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.agent_name}
                                            />
                                            {(errors["agent_name"]?.message || Boolean(errors["agent_name"]?.message) || (isTouched && !watchAllFields.agent_name)) && (
                                                <div className="login-error">
                                                    <Label title={errors.agent_name?.message || "Please Enter First Name."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* Phone */}
                                <Controller
                                    control={control}
                                    name="agent_phone"
                                    rules={{
                                        required: "Please Enter Phone",
                                    }}
                                    render={({ field: { onChange }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Phone</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control ps-3 p-2"
                                                placeholder="Mobile"
                                                onChange={onChange}
                                                onKeyPress={HelperService.allowOnlyNumericValue}
                                                onKeyUp={(e) => HelperService.contactFormatter(e)}
                                                value={watchAllFields.agent_phone}
                                            />
                                            {(errors["agent_phone"]?.message ||
                                                Boolean(errors["agent_phone"]?.message) ||
                                                (isTouched && !watchAllFields.agent_phone)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.agent_phone?.message || "Please Enter Phone."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                {/* Email */}
                                <Controller
                                    control={control}
                                    name="agent_email"
                                    rules={{
                                        required: false,
                                        pattern: {
                                            value: EMAIL_REGEX,
                                            message: "Please Enter Valid Email.",
                                        },
                                    }}
                                    render={({ field: { onChange, onBlur }, fieldState: { isTouched } }) => (
                                        <div className="mb-2">
                                            <Form.Label>Email</Form.Label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Email"
                                                onChange={onChange}
                                                onBlur={onBlur}
                                                value={watchAllFields.agent_email}
                                            />
                                            {(errors["agent_email"]?.message || Boolean(errors["agent_email"]?.message)) && (
                                                <div className="login-error">
                                                    <Label title={errors.agent_email?.message || "Please Enter Email."} modeError={true} />
                                                </div>
                                            )}
                                        </div>
                                    )}
                                />

                                {/* Commission */}
                                <Controller
                                    control={control}
                                    name="comission"
                                    rules={{
                                        required: "Please Enter Commission",
                                    }}
                                    render={({ field: { onChange }, fieldState: { isTouched } }) => (
                                        <div className="mb-4">
                                            <Form.Label>Commission</Form.Label><span className="text-danger">*</span>
                                            <input
                                                type="text"
                                                className="form-control ps-3 p-2"
                                                placeholder="Commission"
                                                onChange={onChange}
                                                onKeyPress={HelperService.allowNewDecimalValue}
                                                value={watchAllFields.comission}
                                            />
                                            {(errors["comission"]?.message ||
                                                Boolean(errors["comission"]?.message) ||
                                                (isTouched && !watchAllFields.comission)) && (
                                                    <div className="login-error">
                                                        <Label title={errors.comission?.message || "Please Enter Commission."} modeError={true} />
                                                    </div>
                                                )}
                                        </div>
                                    )}
                                />

                                <Row className="mb-3">
                                    <Col lg={6} md={6} sm={12} >
                                        {/* commission_type */}
                                        <Controller
                                            control={control}
                                            name="commission_type"
                                            rules={{ required: true }}
                                            render={({ field: { onChange } }) => (
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Commission Type</Form.Label>
                                                    <span className="text-danger">*</span>
                                                    <div className="input-group mb-1">
                                                        <Select
                                                            className="basic-single w-100"
                                                            classNamePrefix="select"
                                                            isSearchable={true}
                                                            options={commissionTypeOptions}
                                                            onChange={(e: any) => { onChange(e.value); }}
                                                            value={commissionTypeOptions?.find((option: any) => option.value === watchAllFields.commission_type)}
                                                            placeholder="Select Commission Type"
                                                        />
                                                    </div>
                                                    {errors.commission_type && (<div className="login-error mb-3"> <Label title={"Please select commission type"} modeError={true} /> </div>)}
                                                </Form.Group>
                                            )}
                                        />
                                    </Col>
                                    <Col lg={6} md={6} sm={12} >
                                        <Controller
                                            control={control}
                                            name="commission_amount"
                                            rules={{
                                                required: "Please Enter Commission Amount",
                                            }}
                                            render={({ field: { onChange }, fieldState: { isTouched } }) => (
                                                <div className="mb-4">
                                                    <Form.Label>Commission Amount</Form.Label><span className="text-danger">*</span>
                                                    <input
                                                        type="text"
                                                        className="form-control ps-3 p-2"
                                                        placeholder="Commission Amount"
                                                        onChange={onChange}
                                                        onKeyPress={HelperService.allowNewDecimalValue}
                                                        value={watchAllFields.commission_amount}
                                                    />
                                                    {(errors["commission_amount"]?.message ||
                                                        Boolean(errors["commission_amount"]?.message) ||
                                                        (isTouched && !watchAllFields.commission_amount)) && (
                                                            <div className="login-error">
                                                                <Label title={errors.commission_amount?.message || "Please Enter Commission Amount."} modeError={true} />
                                                            </div>
                                                        )}
                                                </div>
                                            )}
                                        />
                                    </Col>
                                </Row>

                                {loadingAgentProjectOptions ? (
                                    <div className="">
                                        <div></div>
                                        <div style={{ textAlign: "center", marginTop: "10%" }}>
                                            <img
                                                style={{ position: "relative" }}
                                                src={loader}
                                                alt="No loader found"
                                            />
                                            <div style={{ position: "relative", color: "white" }}>
                                                Loading...
                                            </div>
                                        </div>
                                    </div>
                                ) : null}

                                {
                                    !loadingAgentProjectOptions && agentProjectOptions && agentProjectOptions.length > 0 && <table className="table table-style-1 mt-2 border">
                                        <thead>
                                            <tr>
                                                <th>Project Name</th>
                                                <th>Commission</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {agentProjectOptions.map((item: any) => {
                                                return (
                                                    <tr key={item.id}>
                                                        <td>{item.project_name}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                id={`agentProject-${item.id}`}
                                                                className="form-control input"
                                                                name={`agentProject-${item.id}`}
                                                                onKeyPress={HelperService.allowNewDecimalValue}
                                                                value={item.commission ? item.commission : ""}
                                                                onChange={(e: any) => setAgentProjectOptions(agentProjectOptions.map((project: any) => {
                                                                    if (project.id === item.id) return { ...project, commission: e.target.value }
                                                                    return project;
                                                                }))}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                }

                            </Col>

                        </Row>
                        <div className="text-center border-top">
                            <Button
                                variant="dark"
                                className="btn-brand-1 px-5 mt-3 mb-3 me-2"
                                type="submit"
                                id="changePassword-btn"
                            >
                                {isEdit ? "Update" : "Add"}
                            </Button>
                            <Button
                                variant="light"
                                className="btn-brand-1 px-5 mt-3 mb-3"
                                type="button"
                                onClick={() => closeModal(false)}
                            >
                                Close
                            </Button>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default AddAgent;
